// Detection des URLs media dans le contenu d'un message.
// Les URLs media Discord sont signees (query params) et servies directement ;
// les gifs Tenor sont des liens /view/ rendus via embed.
// Module pur (pas de React) => testable en isolation (voir mediaUrls.test.js).

export const URL_REGEX = /(https?:\/\/[^\s]+)/g;
export const TENOR_REGEX = /^https?:\/\/tenor\.com\/view\/[^\s]+$/i;
export const IMG_REGEX = /^https?:\/\/(?:cdn\.discordapp\.com|media\.discordapp\.net)\/[^\s]+\.(?:png|jpe?g|gif|webp)(\?[^\s]+)?$/i;
// webm sort de l'audio : c'est un conteneur video sur Discord.
export const AUDIO_REGEX = /^https?:\/\/(?:cdn\.discordapp\.com|media\.discordapp\.net)\/[^\s]+\.(?:ogg|mp3|wav|m4a|opus|flac)(\?[^\s]+)?$/i;
export const VIDEO_REGEX = /^https?:\/\/(?:cdn\.discordapp\.com|media\.discordapp\.net)\/[^\s]+\.(?:mp4|mov|webm|mkv|m4v)(\?[^\s]+)?$/i;

// Classe une portion de contenu : 'tenor' | 'image' | 'audio' | 'text'.
export function classifyUrl(part) {
  if (TENOR_REGEX.test(part)) return 'tenor';
  if (IMG_REGEX.test(part)) return 'image';
  if (VIDEO_REGEX.test(part)) return 'video';
  if (AUDIO_REGEX.test(part)) return 'audio';
  return 'text';
}

// Decoupe un contenu en portions (texte + URLs), sans vides, pour le rendu.
export function splitContent(content) {
  return (content || '').split(URL_REGEX).filter((p) => p != null && p !== '');
}
